"use client";

import { UnprotectedLayout } from "@/components";
import { Body, Heading } from "@biom3/react";
import Link from "next/link";

export default function NotFound() {
  return (
    <UnprotectedLayout>
      <Heading>Not found</Heading>
      <Body>We could not find requested resource</Body>
      <Body>
        <Link href="/">Return home</Link>
      </Body>
    </UnprotectedLayout>
  );
}
